module.exports = __webpack_public_path__ + "files/804c856a7c08d95762aedeb50cda2646.png";